import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { CustomerService } from '../services/customer.service';
import { GlobalParams } from '../services/global.service';
import { StorageService } from '../services/storage.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  private readonly storageService = inject(StorageService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly document = inject(DOCUMENT);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const includeAssets = request.url.includes('assets');
    const includeUrl = request.url.includes('http');
    const includeLoginCheck = request.url.includes('login_check');
    const isRefreshTokenRequest = CustomerService.isRefreshTokenRequest(request.url);
    const params = this.storageService.getItem<GlobalParams>('params');

    if (!includeAssets && !includeUrl) {
      if (isRefreshTokenRequest) {
        request = request.clone({
          url: environment.api.url.replace('/ecommerce', '') + request.url,
        });
      } else if (includeLoginCheck) {
        request = request.clone({
          url: environment.api.url + request.url,
        });
      } else {
        const setHeaders: Record<string, string> = {};
        if (params?.country) {
          setHeaders['x-country-code'] = params.country.code;
          setHeaders['x-language-code'] = params.country.locale;
        } else if (!isPlatformBrowser(this.platformId)) {
          // SSR: extract country/locale from the request URL path (e.g. /ES/es/inicio)
          const path = this.document.location?.pathname || '';
          const parts = path.split('/');
          if (parts[1]?.length === 2) {
            setHeaders['x-country-code'] = parts[1].toUpperCase();
          }
          if (parts[2]) {
            setHeaders['x-language-code'] = parts[2];
          }
        }

        request = request.clone({
          url: environment.api.url + request.url,
          setHeaders,
        });
      }
    }

    return next.handle(request);
  }
}
